import type { SettingsResponse } from "@/types";

/**
 * A helper function to fetch settings from the server.
 * For use within the RTK-Query API slices if access to environment variables is needed as slices don't have access to the cache.
 */
export async function fetchSettings() {
  try {
    const settingsResponse = await fetch(
      `https://${globalThis.location.host}/settings`
    );
    if (settingsResponse.ok) {
      const settings = (await settingsResponse.json()) as SettingsResponse;

      if (!settings.apiBaseUrl) {
        throw new Error("API base URL is not set in settings.");
      }

      return settings;
    }
  } catch (error) {
    console.error("Error fetching settings:", error);
    throw error;
  }
}
